export const SESSION_COOKIE_NAME = "session";
export const EMBEDDED_URL_COOKIE_NAME = "embeddedUrl";
export const SPEC_MD_FILENAME = "SPEC.md";
export const DB_SCHEMA_FILENAME = "src/db/schema.ts";
export const API_CODE_FILENAME = "src/index.ts";
export const WRANGLER_JSONC_FILENAME = "wrangler.jsonc";
export const PACKAGE_JSON_FILENAME = "package.json";
export const README_FILENAME = "README.md";
export const R2_PROJECT_TEMPLATE_FILES_DIR = "mega-honc-upload";
export const REDIRECT_COOKIE_NAME = "auth_redirect";
export const DEFAULT_CLOUDFLARE_TYPES_VERSION = "4.20250722.0";
export const RUNTIME_LOGS_PREFIX = "logs/";

// File size limit: 10MB
export const MAX_FILE_SIZE = 10 * 1024 * 1024;

/**
 * Temporary workaround for the fact that we no longer require associating certain records with a spec id
 */
export const FAKE_SPEC_NANO_ID = "todo_remove_spec_reqs";
